import { defineMessages } from "react-intl";

const BulkManagerMessages = defineMessages({
  // Main headers and titles
  header: {
    defaultMessage: "Bulk Manager",
    id: "bulkmanager.formHeader",
  },
  downloadHeader: {
    defaultMessage: "Download",
    id: "bulkmanager.download.header",
  },
  downloadButton: {
    defaultMessage: "Download",
    id: "bulkmanager.download.button",
  },
  uploadHeader: {
    defaultMessage: "Upload",
    id: "bulkmanager.upload.header",
  },
  batches: {
    defaultMessage: "History",
    id: "bulkmanager.history.title",
  },

  // Form-related messages
  actionField: {
    defaultMessage: "Choose Action",
    id: "bulkmanager.form.actionField",
  },
  edit: {
    defaultMessage: "Edit",
    id: "bulkmanager.form.edit",
  },
  create: {
    defaultMessage: "Create",
    id: "bulkmanager.form.create",
  },
  entityField: {
    defaultMessage: "Entity",
    id: "bulkmanager.form.entityField",
  },
  campaignEntity: {
    defaultMessage: "Campaigns",
    id: "bulkmanager.form.campaignEntity",
  },
  strategyEntity: {
    defaultMessage: "Strategies",
    id: "bulkmanager.form.strategyEntity",
  },
  organization: {
    defaultMessage: "Organization",
    id: "bulkmanager.form.organization",
  },
  agency: {
    defaultMessage: "Agency",
    id: "bulkmanager.form.agency",
  },
  advertiser: {
    defaultMessage: "Advertiser",
    id: "bulkmanager.form.advertiser",
  },
  campaign: {
    defaultMessage: "Campaigns",
    id: "bulkmanager.form.campaign",
  },
  strategy: {
    defaultMessage: "Strategies",
    id: "bulkmanager.form.strategy",
  },

  // Upload-related messages
  uploadExcelWorkbook: {
    defaultMessage: "Drag and drop files here to upload Excel Workbook",
    id: "bulkmanager.upload.excelWorkbook",
  },
  uploadPostalCodeFiles: {
    defaultMessage: "Drag and drop files here to attach Postal Code CSV files",
    id: "bulkmanager.upload.postalCodeFiles",
  },
  uploadButton: {
    defaultMessage: "Upload",
    id: "bulkmanager.upload.button",
  },
  uploadSuccessMessage: {
    defaultMessage:
      "Your upload request was received. You can track progress in History.",
    id: "bulkmanager.upload.success.message",
  },
  downloadUploadRequestReceived: {
    defaultMessage: "Request Received",
    id: "bulkmanager.downloadUpload.requestReceived",
  },
  addCsvFiles: {
    defaultMessage: "Add CSV Files?",
    id: "bulkmanager.upload.addCsvFiles",
  },
  willUploadPostalCodes: {
    defaultMessage: "Yes",
    id: "bulkmanager.form.willUploadPostalCodes",
  },
  willNotUploadPostalCodes: {
    defaultMessage: "No",
    id: "bulkmanager.form.willNotUploadPostalCodes",
  },

  // Batches-related messages
  startDate: {
    defaultMessage: "START DATE",
    id: "bulkmanager.history.startDate",
  },
  completionDate: {
    defaultMessage: "COMPLETION DATE",
    id: "bulkmanager.history.completionDate",
  },
  actionType: {
    defaultMessage: "ACTION TYPE",
    id: "bulkmanager.history.actionType",
  },
  fileName: {
    defaultMessage: "FILE NAME",
    id: "bulkmanager.history.fileName",
  },
  status: {
    defaultMessage: "STATUS",
    id: "bulkmanager.history.status",
  },
  DOWNLOAD: {
    defaultMessage: "DOWNLOAD",
    id: "bulkmanager.history.download",
  },
  UPLOAD: {
    defaultMessage: "UPLOAD",
    id: "bulkmanager.history.upload",
  },

  // Status messages
  statusProcessing: {
    defaultMessage: "Processing",
    id: "bulkmanager.status.processing",
  },
  statusComplete: {
    defaultMessage: "Complete",
    id: "bulkmanager.status.complete",
  },
  statusPartial: {
    defaultMessage: "Partial Success",
    id: "bulkmanager.status.partial",
  },
  statusUploadCancelled: {
    defaultMessage: "Upload Cancelled",
    id: "bulkmanager.status.uploadCancelled",
  },
  statusDownloadCancelled: {
    defaultMessage: "Download Cancelled",
    id: "bulkmanager.status.downloadCancelled",
  },
  statusError: {
    defaultMessage: "Error",
    id: "bulkmanager.status.error",
  },
  statusCancelling: {
    defaultMessage: "Cancelling",
    id: "bulkmanager.status.cancelling",
  },
  statusWaiting: {
    defaultMessage: "Waiting",
    id: "bulkmanager.status.waiting",
  },
  cancelButton: {
    defaultMessage: "Cancel",
    id: "bulkmanager.status.cancelButton",
  },
  errorSummary: {
    defaultMessage:
      "{entity} returned errors. Please download the summary file for more details",
    id: "bulkmanager.status.errorSummary",
  },

  // Field-related messages
  nestedFieldsLabel: {
    defaultMessage: "Fields",
    id: "bulkmanager.form.nestedFieldsLabel",
  },
  filterFieldsLabel: {
    defaultMessage: "Filters",
    id: "bulkmanager.form.filterFieldsLabel",
  },
  searchByNameLabel: {
    defaultMessage: "Search by Name",
    id: "bulkmanager.form.searchByNameLabel",
  },
  searchByIdLabel: {
    defaultMessage: "Search by Id",
    id: "bulkmanager.form.searchByIdLabel",
  },
  selectAll: {
    defaultMessage: "Select All",
    id: "bulkmanager.form.selectAll",
  },
  search: {
    defaultMessage: "Search",
    id: "bulkmanager.form.search",
  },
  selectEntityToSearchBy: {
    defaultMessage: "Select Entity to Search By",
    id: "bulkmanager.form.selectEntityToSearchBy",
  },
  selectFields: {
    defaultMessage: "Select Fields",
    id: "bulkmanager.fields.selectFields",
  },

  // Nested field names
  budgetFlights: {
    defaultMessage: "Budget Flights",
    id: "bulkmanager.fields.budgetFlights",
  },
  vendorAgreements: {
    defaultMessage: "Vendor Agreements",
    id: "bulkmanager.fields.vendorAgreements",
  },
  campaignSiteLists: {
    defaultMessage: "Campaign Site Lists",
    id: "bulkmanager.fields.campaignSiteLists",
  },
  audiencesInBrain: {
    defaultMessage: "Audiences in Brain",
    id: "bulkmanager.fields.audiencesInBrain",
  },
  deals: {
    defaultMessage: "Deals",
    id: "bulkmanager.fields.deals",
  },
  dealGroups: {
    defaultMessage: "Deal Groups",
    id: "bulkmanager.fields.dealGroups",
  },
  supplies: {
    defaultMessage: "Supplies",
    id: "bulkmanager.fields.supplies",
  },
  thirdPartyAudiences: {
    defaultMessage: "3rd Party Audiences",
    id: "bulkmanager.fields.thirdPartyAudiences",
  },
  creativeGroups: {
    defaultMessage: "Creative Groups",
    id: "bulkmanager.fields.creativeGroups",
  },
  contextualSegments: {
    defaultMessage: "Contextual Segments",
    id: "bulkmanager.fields.contextualSegments",
  },
  dayPart: {
    defaultMessage: "Day Part",
    id: "bulkmanager.fields.dayPart",
  },
  siteLists: {
    defaultMessage: "Site Lists",
    id: "bulkmanager.fields.siteLists",
  },
  locationTechnologyVideo: {
    defaultMessage: "Location, Technology & Video",
    id: "bulkmanager.fields.locationTechnologyVideo",
  },
  postalCodes: {
    defaultMessage: "Postal Codes",
    id: "bulkmanager.fields.postalCodes",
  },
  downloadErrorTitle: {
    defaultMessage: "Download Failed",
    id: "bulkmanager.download.error.title",
  },
  downloadErrorMessage: {
    defaultMessage:
      "There was an error downloading the file. Please try again.",
    id: "bulkmanager.download.error.message",
  },
  downloadSuccessMessage: {
    defaultMessage:
      "Your download request was received. You can track progress in History.",
    id: "bulkmanager.download.success.message",
  },
  errorTitle: {
    defaultMessage: "Error",
    id: "bulkmanager.error.title",
  },
  cancelJobError: {
    defaultMessage: "Failed to cancel job. Please try again.",
    id: "bulkmanager.error.cancelJob",
  },
  searchByIdPlaceholder: {
    defaultMessage: "Enter IDs (comma or newline separated)",
    id: "bulkmanager.form.searchByIdPlaceholder",
  },
  uploadErrorSelectExcel: {
    defaultMessage: "Please select an Excel file",
    id: "bulkmanager.upload.error.selectExcel",
  },
  uploadErrorSelectPostalCode: {
    defaultMessage: "Please select at least one postal code file",
    id: "bulkmanager.upload.error.selectPostalCode",
  },
  downloadResultFile: {
    defaultMessage: "Download result file",
    id: "bulkmanager.download.resultFile",
  },
  unnamedFile: {
    defaultMessage: "Unnamed File",
    id: "bulkmanager.file.unnamed",
  },

  // Search filter messages
  activeOnly: {
    defaultMessage: "Active Only",
    id: "bulkmanager.search.filters.activeOnly",
  },
  hideExpired: {
    defaultMessage: "Hide Expired",
    id: "bulkmanager.search.filters.hideExpired",
  },
});

export default BulkManagerMessages;
